/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';

const getUserFacility = async (): Promise<any> => {
  const {userToken, setUserDetails, userDetails} = useUserStore.getState();

  if (userDetails.facility !== undefined) {
    try {
      const res = await axios.request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.facilityDetails}/${userDetails.facility}`,
        headers: {
          Authorization: `Bearer ${userToken}`
        },
        params: {}
      });

      setUserDetails({...userDetails, facilityName: res.data.data?.name});

      return res.data.data;
    } catch (err) {}
  }
};

export default getUserFacility;
